import React from "react";
import styles from "./../styles.module.css";

const HeaderPhoneSelector: React.FC<{
	heading: string;
	colours: string[];
	storage: string[];
	setStorage: (storage: string) => void;
	setColour: (colour: string) => void;
}> = ({ heading, colours, storage, setStorage, setColour }) => {
	const [selectedColour, setSelectedColour] = React.useState("");
	const [selectedStorage, setSelectedStorage] = React.useState("");

	const handleColourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setSelectedColour(event.target.value);
		setColour(event.target.value);
	};

	const handleStorageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setSelectedStorage(event.target.value);
		setStorage(event.target.value);
	};

	const handleReset = () => {
		setSelectedColour("");
		setSelectedStorage("");
		setColour("");
		setStorage("");
	};

	return (
		<div className="container">
			<div className="row">
				<div className="d-flex justify-content-center align-items-center mt-5">
					<div className="phone_select__container ">
						<h2>{heading}</h2>
						<select
							className="phone_select"
							onChange={handleColourChange}
							value={selectedColour}
						>
							<option value="">Any Colour</option>
							{colours.map((colour) => (
								<option key={colour} value={colour}>
									{colour}
								</option>
							))}
						</select>
						<select
							className="phone_select"
							onChange={handleStorageChange}
							value={selectedStorage}
						>
							<option value="">Any Storage</option>
							{storage.map((storageOption) => (
								<option key={storageOption} value={storageOption}>
									{storageOption}
								</option>
							))}
						</select>
						<button
							type="button"
							className={`${styles.reset_color_storage}`}
							title={"Change Postcode"}
							onClick={handleReset}
						>
							Reset Colour and Storage
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeaderPhoneSelector;
